
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 115.947 69.203"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M115.947 34.601S89.991 69.202 57.973 69.202 0 34.601 0 34.601 25.956 0 57.974 0s57.973 34.601 57.973 34.601z"}}),_c('circle',{attrs:{"fill":"#29ABE2","cx":"57.974","cy":"34.601","r":"25.254"}})])
          )
        }
      }
    